import { createAction, props } from '@ngrx/store';

export const ProductsActionTypes = {
    LOAD_PRODUCTS: '[product] LOAD_PRODUCTS',
    LOAD_PRODUCTS_WITH_PRODUCTS: '[product] LOAD_PRODUCTS_WITH_PRODUCTS',
    LOAD_PRODUCTS_WITH_IDS: '[product] LOAD_PRODUCTS_WITH_IDS',
    LOAD_PRODUCTS_SUCCESS: '[product] LOAD_PRODUCTS_SUCCESS',
    LOAD_PRODUCTS_ERROR: '[product] LOAD_PRODUCTS_ERROR',
};

export const LoadProductsAction = createAction(
    ProductsActionTypes.LOAD_PRODUCTS,
    props<{ ids: string; categoryId: string }>()
);
export const LoadProductsWithProductsAction = createAction(
    ProductsActionTypes.LOAD_PRODUCTS_WITH_PRODUCTS,
    props<{ ids: string; categoryId: string }>()
);
export const LoadProductsWithIdsAction = createAction(
    ProductsActionTypes.LOAD_PRODUCTS_WITH_IDS,
    props<{ ids: string; categoryId: string }>()
);
export const LoadProductsSuccessAction = createAction(ProductsActionTypes.LOAD_PRODUCTS_SUCCESS);
export const LoadProductsErrorAction = createAction(ProductsActionTypes.LOAD_PRODUCTS_ERROR);
